import { useState, useCallback } from 'react';

export const useToast = () => {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, type = 'info', duration = 5000, position = 'top-right') => {
    const id = Date.now() + Math.random();
    const newToast = {
      id,
      message,
      type,
      duration,
      position
    };
    
    setToasts(prev => [...prev, newToast]);
    return id;
  }, []);

  const removeToast = useCallback((id) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  }, []);

  const showSuccess = useCallback((message, duration, position) => {
    return addToast(message, 'success', duration, position);
  }, [addToast]);

  const showError = useCallback((message, duration, position) => {
    return addToast(message, 'error', duration, position);
  }, [addToast]);

  const showWarning = useCallback((message, duration, position) => {
    return addToast(message, 'warning', duration, position);
  }, [addToast]);

  const showInfo = useCallback((message, duration, position) => {
    return addToast(message, 'info', duration, position);
  }, [addToast]);

  const clearAllToasts = useCallback(() => {
    setToasts([]);
  }, []);

  // Backward compatible showToast function
  const showToast = useCallback((message, type = 'info', duration, position) => {
    return addToast(message, type, duration, position);
  }, [addToast]);

  return {
    toasts,
    addToast,
    removeToast,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    showToast, // For backward compatibility
    clearAllToasts
  };
};

export default useToast;